export default __webpack_public_path__ + "static/soehne-web-halbfett-kursiv-84004c3c4967bcb930261282d5089504.woff2";